<div class="modal-header" style="background-color: #ffffff;">
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="misc-wrapper">
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="46" /></a
  >
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">{{ 'bloc.sno' | translate}} 🔐</h2>
      <p class="mb-2">
        {{ 'bloc.dsno' | translate}}
      </p>
      <a class="btn btn-primary mb-2 btn-sm-block" (click)="verf()" rippleEffect
        > {{ 'verf.verCompte' | translate}}</a
      ><img
        class="img-fluid"
        [src]="
          coreConfig.layout.skin === 'dark'
            ? 'assets/images/pages/not-authorized-dark.svg'
            : 'assets/images/pages/not-authorized.svg'
        "
        alt="Not authorized page"
      />
    </div>
  </div>
</div>
    